import React, { useEffect, useState } from 'react';
import { fetchKnowledgeGraphSources } from '../services/dashboardService';

const IntelligenceSources = ({ onViewInGraph }) => {
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadSources = async () => {
      try {
        setLoading(true);
        const result = await fetchKnowledgeGraphSources();
        if (result.success) {
          setSources(result.data);
        } else {
          setError(result.message || 'Failed to load sources');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadSources();
  }, []);

  if (loading) return <div className="loading">Loading intelligence sources...</div>;
  if (error) return <div className="error-message">Error: {error}</div>;

  return (
    <div className="intelligence-table-container">
      <div className="table-header-row">
        <h3>Intelligence Sources Reconciliation</h3>
        <p className="subtitle">Audit trail of document-to-entity extractions</p>
      </div>
      
      <table className="intelligence-table">
        <thead>
          <tr>
            <th>File Name</th>
            <th>Provider</th>
            <th>Connections Produced</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sources.map((source, index) => (
            <tr key={index}>
              <td>
                <div className="file-info">
                  <i className="fas fa-file-pdf"></i>
                  <span>{source.file_name}</span>
                </div>
              </td>
              <td>{source.provider}</td>
              <td>
                <span className="connection-badge">
                  {source.connections_found} connections
                </span>
              </td>
              <td>
                <div className="action-buttons">
                  <a href={source.url} target="_blank" rel="noopener noreferrer" className="btn-icon" title="View PDF">
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                  <button 
                    className="btn-primary btn-sm"
                    onClick={() => onViewInGraph(source.file_name)}
                  >
                    View in Graph
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default IntelligenceSources;
